export class MailPropertiesDto {
    keyId: string = '';
    id: string = '';
    username: string = '';
    password: string = '';
    mailHost: string = '';
    mailFrom: string = '';
    mailPort: number = 25;
    smtpAuth: number = 0;
    smtpSsl: number = 0;
    remarks: string = '';
}